function retruncateDesc(){
 // var tag = document.querySelector("#rkc-resize").style.color = "magenta";
 var tag = document.querySelector(".rkc-resize");
 var tag2 = document.querySelector(".rkc-recolor");
  tag.style.height = "110px"; 
  tag.style.overflow = "hidden"; 
  tag2.style.backgroundColor = "white";
}
/*
var readItem2 = this.addEventListener("click", myFunction);
function myFunction(readItem2) {
//var phrase1 = document.querySelector("h2").textContent = "Woodworking";  
document.body.innerHTML = document.body.innerHTML.replace('Woodworking', 'hi');
   console.log("CLICKED ON");
}
*/
/*
var readItem = this.addEventListener("click", myFunction);
function myFunction(readItem) {
    //document.getElementById("demo").innerHTML = "YOU CLICKED ME!";
  console.log("CLICKED");
  //var currentIndex = $('.slick-current').attr('data-slick-index');
  console.log($(this).index('.slick-track'));
  //console.log($(this).slick().$slides.get(index));
  var tt = jQuery('li.grid__item').prop('outerHTML');
  var tt2 = $(tt).slick();
  console.log(tt2.$data-slick-index);
  
}
*/
  /*
function inspectFormValue(){

  console.log("inspected");
  var result = document.getElementsByClassName("single-option-selector")[0].innerHTML;
  var result2 = document.getElementsByClassName("single-option-selector");
 var result3 = document.querySelector("select");
var result4 = result3.getAttribute("data-index");
  
  var test1 = document.getElementById("SingleOptionSelector-0");
  var test2 = document.getElementById("SingleOptionSelector-0")[0];
  var test2b = document.getElementById("SingleOptionSelector-0")[1];
  //inspect nodes
  var test2c = document.getElementById("SingleOptionSelector-0").childNodes[3].firstChild.textContent;
  //var test2d = test2c.getElementById("text");
  var test2x = document.getElementById("SingleOptionSelector-0").childNodes[1].nextElementSibling;
  //var test2c = document.getElementById("SingleOptionSelector-0").childNodes[0].textContent;
  test2c.value = "new value";
  //var c = document.getElementById("SingleOptionSelector-0");
  //c[1].style.backgroundColor = "yellow";
  var a = document.querySelector("li");
  var a2 = document.querySelector(".slick-track").innerHTML;
  var a3 = document.querySelector(".slick-track").li;
  //THIS IS CLOSER!!! -------------------------------------------
  //slick is not defined
  
  
  //var $tt = jQuery('li.grid__item').prop('outerHTML').data-slick-index();
  var tt = jQuery('li.grid__item').prop('outerHTML');
  //NOTE! data-slick-index will be -3 because the CLASS starts with -3, but the clone (#) will be +1 that
  var tt2 = $(tt).slick();
  var tt2b = $(tt).slide();
  var tt3 = tt2.slickIndex;
  //li and data-slick-index
  //var a = document.querySelector("Classic Brass Knob ~ 1");
  var b = document.querySelector(".single-option-selector-product-template");
  //THIS PART ACUTALLY WORKS PER INDEX OF FORM----------------------------------
  var c = document.querySelector(".product-form__input")[0];
  var c2 = document.querySelector(".product-form__input");
  c2.style.backgroundColor = "yellow";
  //c.style.color = "black";
  //CHANGE THE TEXT------------------
  //c.textContent = c2[1].textContent;
  c.textContent = "TESTING THIS!!!";
  //var test3 = document.getElementById("SingleOptionSelector-0")[0].innerHTML;
 // document.querySelector("select").setAttribute("data-index", "5");
 
  
 // console.log(c[0].textContent);
  //console.log(a);
  //it's in an LI outside of this one
   //console.log(a2);
  var testNew = document.getElementById("li");
  //var testNew2 =  this.slick();
  console.log("output");
  //console.log($(slide.$slides.get(index)).attr('id'))
  //console.log(tt2b);
  //.getAttribute('data-index');
  


  
}
  */